// import axios from '@/utils/axios';

// export const getBranches = async () => {
//   const response = await axios.get(`/branches`);
//   return response.data.data;
// };
import axios from '@/utils/axios';

let branchCache = null;

export const getBranches = async () => {
  // Cache mein hai toh API mat maaro
  if (branchCache) {
    return branchCache;
  }

  try {
    const response = await axios.get('/branches');
    branchCache = response.data.data;
    return branchCache;
  } catch (error) {
    console.log(error.message);
    return [];
  }
};

// Logout pe cache clear karo
export const clearBranchCache = () => {
  branchCache = null;
};